import store from "../store/index.js";
export default{
    open(){
        console.log("哈哈哈我是公共Api");
        console.log(store)
        console.log(store.state.i)//访问vueX的数据
        store.commit("ceshi",2)//修改vueX的数据
    },
    /**
	* Element的msg提示弹窗
	* @param {string} msg   提示语
    * @param {number} myType  类型 1 成功 2 警告 3 普通 4 错误
    * @param {number} time  时间 毫秒
	*/
    myMessage(msg, myType, time){
        switch(myType){
            case 1:
                this.$message({message: msg, type: 'success', duration: time });
                break;
            case 2:
                this.$message({message: msg, type: 'warning', duration: time });
                break;
            case 3:
                this.$message({message: msg, duration: time });
                break;
            case 4:
                this.$message({message: msg, type: 'error', duration: time });
                break;
        }
    },
    /**
	* 初始化TIC
	* @param {string} sdkAppId  密匙
    */
    initTic(sdkAppId){
        let tic = new TIC({});
        tic.init(sdkAppId, res => {
            if (res.code) {
                console.log("TIC ==> 初始化失败");
            }else {
                let tim = tic.getImInstance();
            }
        });
    },
}